import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    sheetsFormInput: {
      width: '300px',
      borderRadius: '3px',
    },
    sheetInput: {
      backgroundColor: 'white',
    },
    selectedSheet: {
      border: '1px solid rgba(44, 45, 62, 0.3)',
      borderRadius: '3px',
      margin: '2px 4px',
      padding: '4px',
      fontSize: '12px',
      maxWidth: '310px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    textOutline: {
      lineHeight: '16px',
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
    },
    line: {
      marginRight: '10px',
      marginLeft: '18px',
      width: '70px',
      height: '0px',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.4,
      display: 'inline-block',
      align: 'center',
    },
    subjectText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      display: 'inline',
      fontSize: '14px',
    },
    checkboxColor: {
      color: '#3C419A',
    },
  }),
);
